import type { LivingUniverseCore, LivingUniverseSnapshot, RestoreResult } from "./living-universe-core";

export interface BrowserPersistence {
  restore(atMs?: number): RestoreResult;
  save(atMs?: number): boolean;
  clear(): void;
}

export function createBrowserPersistence(
  core: LivingUniverseCore,
  storageKey = `inyron:living-universe:${core.gameId}:${core.worldId}`,
): BrowserPersistence {
  const storage = typeof window !== "undefined" ? window.localStorage : null;
  return {
    restore(atMs = Date.now()): RestoreResult {
      if (!storage) return { entities: 0, biographies: 0, causes: 0, relationships: 0, offlineSeconds: 0 };
      try {
        const raw = storage.getItem(storageKey);
        return raw ? core.restore(JSON.parse(raw) as LivingUniverseSnapshot, atMs) : {
          entities: 0, biographies: 0, causes: 0, relationships: 0, offlineSeconds: 0,
        };
      } catch {
        return { entities: 0, biographies: 0, causes: 0, relationships: 0, offlineSeconds: 0 };
      }
    },
    save(atMs = Date.now()): boolean {
      if (!storage) return false;
      try {
        storage.setItem(storageKey, JSON.stringify(core.snapshot(atMs)));
        return true;
      } catch {
        return false;
      }
    },
    clear(): void {
      try { storage?.removeItem(storageKey); } catch { /* best-effort storage */ }
    },
  };
}
